module.exports = __webpack_public_path__ + "img/sameday-active.d32c5685.svg";